<template>
<div class="chapter">
<div class="inner_page">
<p><a id="toc"></a></p><a id="toc">
<div class="fmh1">Table of Contents</div>
<div> <br/></div>
</a><div class="cfmh"><a id="toc"></a><a href="#/nige_9781569759394_oeb_tp_r1">Title Page</a></div>
<div class="cfmh"><a href="#/nige_9781569759394_oeb_itr_r1">Introduction</a></div>
<div> <br/></div>
<div class="cct"><a href="#/nige_9781569759394_oeb_c01_r1">chapter 1 - Natural Born Killers</a></div>
<div class="cct"><span href="#/nige_9781569759394_oeb_c02_r1" title="Link target outside of Sample">chapter 2 - The Boston Strangler</span></div>
<div class="cct"><span href="#/nige_9781569759394_oeb_c03_r1" title="Link target outside of Sample">chapter 3 - Australian Spree Killers</span></div>
<div class="cct"><span href="#/nige_9781569759394_oeb_c04_r1" title="Link target outside of Sample">chapter 4 - Sniper in the Tower</span></div>
<div class="cct"><span href="#/nige_9781569759394_oeb_c05_r1" title="Link target outside of Sample">chapter 5 - The Zodiac Killer</span></div>
<div class="cct"><span href="#/nige_9781569759394_oeb_c06_r1" title="Link target outside of Sample">chapter 6 - The Family</span></div>
<div class="cct"><span href="#/nige_9781569759394_oeb_c07_r1" title="Link target outside of Sample">chapter 7 - The Moors Murderers</span></div>
<div class="cct"><span href="#/nige_9781569759394_oeb_c08_r1" title="Link target outside of Sample">chapter 8 - Ted Bundy</span></div>
<div class="cct"><span href="#/nige_9781569759394_oeb_c09_r1" title="Link target outside of Sample">chapter 9 - The Yorkshire Ripper</span></div>
<div class="cct"><span href="#/nige_9781569759394_oeb_c10_r1" title="Link target outside of Sample">chapter 10 - Son of Sam</span></div>
<div class="cct"><span href="#/nige_9781569759394_oeb_c11_r1" title="Link target outside of Sample">chapter 11 - Dennis Nilsen</span></div>
<div class="cct"><span href="#/nige_9781569759394_oeb_c12_r1" title="Link target outside of Sample">chapter 12 - The Night Stalker</span></div>
<div class="cct"><span href="#/nige_9781569759394_oeb_c13_r1" title="Link target outside of Sample">chapter 13 - Hungerford</span></div>
<div class="cct"><span href="#/nige_9781569759394_oeb_c14_r1" title="Link target outside of Sample">chapter 14 - Jeffrey Dahmer</span></div>
<div class="cct"><span href="#/nige_9781569759394_oeb_c15_r1" title="Link target outside of Sample">chapter 15 - The House of Horrors</span></div>
<div class="cct"><span href="#/nige_9781569759394_oeb_c16_r1" title="Link target outside of Sample">chapter 16 - Doctor Death</span></div>
<div class="cct"><span href="#/nige_9781569759394_oeb_c17_r1" title="Link target outside of Sample">chapter 17 - Columbine</span></div>
<div> <br/></div>
<div class="cbmh"><span href="#/nige_9781569759394_oeb_bm1_r1" title="Link target outside of Sample">Other Books by Ulysses Press</span></div>
<div class="cbmh"><span href="#/nige_9781569759394_oeb_ata_r1" title="Link target outside of Sample">About the Author</span></div>
<div class="cbmh"><span href="#/nige_9781569759394_oeb_cop_r1" title="Link target outside of Sample">Copyright Page</span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nige_9781569759394_oeb_toc_r1.vue?4b797a5e